import React, { useRef } from 'react';

import './index.module.less';
import { IPickerProps } from './index.d';
import Column from './Column';

const Picker = (props: IPickerProps) => {
  const { onClose, onConfirm, title, cancelBtnText, confirmBtnText,  columns, onPick  } = props;
  const container = useRef(null);
  const isConfirm = useRef(null);

  const animationEnd = (event: any): void => {
    if (!event || event.animationName === 'moveDown') {
      if (isConfirm.current) {
        onConfirm && onConfirm();
      } else {
        onClose && onClose();
      }
    }
  };

  const close = (event?: any): void => {
    if (!event || event.target?.id) {
      const name = (container.current as any).className.replace(
        'in-up',
        'out-down',
      );
      (container.current as any).className = name;
    }
  };
  const confirm = async () => {
    isConfirm.current = true;
    close();
  };

  return (
    <div id="containerModal" className="flex bg-modal" onClick={close}>
      <div
        className="move-in-up"
        styleName="modal-content"
        ref={container}
        onAnimationEnd={animationEnd}
      >
        <div className="flex" styleName="modal-header">
          <span styleName="header-title">{title || '请选择'}</span>
        </div>
        <div className="flex" styleName="body">
          <div styleName="highlight" />
          {
            columns.map((item, i) => (
              <Column key={ i }
                { ...item }
                values={item.values}
                index={ i }
                onChosen={ onPick }
              />
            ))
          }
        </div>
        <div className="flex" styleName="modal-bottom-wrapper">
          <div
            className="flex flex-center"
            styleName="modal-cancel-btn"
            id="close-btn"
            onClick={close}
          >
            {cancelBtnText || '取消'}
          </div>
          <div
            className="flex flex-center"
            styleName="modal-confirm-btn"
            onClick={confirm}
          >
            {confirmBtnText || '确定'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Picker;
